import { render, staticRenderFns } from "./FormulasBlockTemplates.vue?vue&type=template&id=436c0239&scoped=true"
import script from "./FormulasBlockTemplates.vue?vue&type=script&lang=js"
export * from "./FormulasBlockTemplates.vue?vue&type=script&lang=js"
import style0 from "./FormulasBlockTemplates.vue?vue&type=style&index=0&id=436c0239&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436c0239",
  null
  
)

export default component.exports